import { useState } from 'react';
import EmpresasUnidadesOrgTab from '../../Tabs/EmpresasUnidadesOrgTab';

const tabsList = [
    { key: 'unidadesOrg', label: 'Unidades Organizacionales' },
];

export default function EmpresasTabs({ empresaId }) {
    const [active, setActive] = useState('unidadesOrg');
    const hasValidContext = Number(empresaId || 0) > 0;

    if (!hasValidContext) {
        return (
            <div className="person-tabs-disabled">
                <span>
                    Selecciona o crea una empresa y pulsa <b>Editar</b> para gestionar sus datos relacionados.
                </span>
            </div>
        );
    }

    return (
        <div className="person-tabs-wrap">
            <div className="person-tabs-bar">
                {tabsList.map((t) => (
                    <button
                        key={t.key}
                        className={`person-tab ${active === t.key ? 'is-active' : ''}`}
                        onClick={() => setActive(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="person-tab-panel">
                {active === 'unidadesOrg' && <EmpresasUnidadesOrgTab fkValue={empresaId} />}
            </div>
        </div>
    );
}
